export default __webpack_public_path__ + "9a17786234899efcc9639fcc31fcecf3.svg";